import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import PublicIcon from '@mui/icons-material/Public'
import { ADMIN_ROLES, SITE_ADMIN_ROLES } from '@/lib/roles'
import { adminNavGroups, siteAdminNavGroups } from '@/navConfig'

/**
 * The two admin areas that share one shell: an organisation's own Admin, and
 * the platform operator's Site admin. Everything that differs between them —
 * where they live, what they're called, who may use them, and their
 * categories — is here, so AdminLayout, its navs and the overview cards are
 * written once.
 */
export const ADMIN_AREAS = {
    admin: {
        id: 'admin',
        rootPath: '/admin',
        title: 'Admin',
        overviewLabel: 'Admin overview',
        searchLabel: 'Search admin pages',
        roles: ADMIN_ROLES,
        icon: <AdminPanelSettingsIcon fontSize="small" />,
        groups: adminNavGroups
    },
    siteAdmin: {
        id: 'siteAdmin',
        rootPath: '/site-admin',
        title: 'Site admin',
        overviewLabel: 'Site admin overview',
        searchLabel: 'Search site admin pages',
        roles: SITE_ADMIN_ROLES,
        icon: <PublicIcon fontSize="small" />,
        groups: siteAdminNavGroups
    }
}
